// extracted by mini-css-extract-plugin
module.exports = {"lab-icon":"lab-icon_lab-icon__nx19N","completed":"lab-icon_completed__K2_hk"};